import { Users, CreditCard, Building2, Calendar } from "lucide-react";

const ImpactSnapshot = () => {
  const metrics = [
    { value: "3000+", label: "Care-leavers connected", icon: Users },
    { value: "800+", label: "Verified CLiC IDs", icon: CreditCard },
    { value: "13", label: "State Government Invitations", icon: Building2 },
    { value: "3-Year", label: "Rajasthan Implementation Track", icon: Calendar }
  ];

  return (
    <section className="py-10 bg-white border-y border-[#E5E7EB]" data-testid="impact-snapshot-section">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Title */}
        <div className="text-center mb-6">
          <p className="text-[10px] font-semibold text-[#6E6E6E] uppercase tracking-widest mb-2">
            Institutional Impact Snapshot
          </p>
          <p className="text-xs text-[#9CA3AF]">As of Jan 2026</p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {metrics.map((metric, index) => (
            <div 
              key={index}
              className="text-center p-4 rounded-lg bg-[#F8F9F7] border border-[#E5E7EB]"
              data-testid={`metric-card-${index}`}
            >
              <div className="w-8 h-8 mx-auto mb-2 rounded-full bg-[#1F7A5A]/10 flex items-center justify-center">
                <metric.icon className="w-4 h-4 text-[#1F7A5A]" />
              </div>
              <p className="text-2xl md:text-3xl font-bold text-[#1F7A5A]">{metric.value}</p>
              <p className="text-xs text-[#6E6E6E] mt-1">{metric.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSnapshot;
